import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Draggable from '../draggable';

export default class DraggableStop extends Component {
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  onDragStart({ target }) {
    // Disable overflow
    $(target).parents('.window-body').css('overflow', 'visible');
  }

  onDragEnd(e) {
    const position = Draggable.latLng(e, this.props.overlayView, $('#map-network-manage').offset());

    $(this.icon).css('transform', '').data({ x: 0, y: 0 });
    $(e.target).parents('.window-body').css('overflow', '');

    $('#stop_lat').val(position.lat());
    $('#stop_lng').val(position.lng());
    $('#stop_coordinates').val(`${position.lat()}, ${position.lng()}`);
    this.props.onMarkerAdded(position);
  }

  render() {
    return (
      <Draggable onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
        <div className="icon" ref={(icon) => { this.icon = icon; }}>
          <i className="fa fa-bus" />
        </div>
      </Draggable>
    );
  }
}

DraggableStop.propTypes = {
  overlayView: PropTypes.instanceOf(google.maps.OverlayView).isRequired,
  onMarkerAdded: PropTypes.func.isRequired,
};
